<template>
  <div class="recommended">
    <div v-for="(item, index) in showRecommended" :key='index'
         class="mobile-recommended" :class="{padding:padding}">
      <div v-if="item && item.Products.length !== 0" class="recommended-container">
        <h2 class="section-header__title" v-if="curIsEnglish">- {{item.Name}} -</h2>
        <h2 class="section-header__title" v-if="curIsChinese">{{ item.Description }}</h2>
        <ul>
          <li v-for="(p, index) in item.Products" :key='index'>
            <mobileProductCardLarge v-bind:img="p.Thumbnail"
                                    v-bind:link="p.link"
                                    v-bind:brand="p.Brand"
                                    v-bind:rating="p.Rating"
                                    v-bind:name="curIsEnglish ? p.Name : p.Description"
                                    v-bind:isPromotion="p.IsPromotion"
                                    v-bind:price="p.Price"
                                    v-bind:item="p"
                                    v-bind:quantity="p.Quantity"
                                    v-bind:key="index"
            ></mobileProductCardLarge>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import mobileProductCardLarge from "./mobile/mobileProductCardLarge";
import {locales, outOfStockSorts, showRecommendedData} from "../mixin";

export default {
  name: "recommended",
  mixins: [showRecommendedData, outOfStockSorts, locales],
  components: {
    mobileProductCardLarge,
  },
  props: ['padding']
}
</script>

<style scoped lang="less">
.mobile-recommended{
  display: none;
}
.mobile-recommended{
  display: block;
  padding-top: 50px;
  &.padding{
    padding-left: 16px;
    padding-right: 16px;
  }
  .section-header__title{
    font-size: 14px !important;
    text-align: center;
    font-weight: 600;
  }
  ul {
    width: 100%;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    li {
      width: calc(50% - 7px) !important;

      .product-card-large {
        margin: 0 0 14px 0;

        .product_box {
          padding: 10px;
          width: 100%;

          .Pro-Details {
            width: 100%;

            .price-bot {
              .review-container-card {
                .star-img-container {
                  display: flex;
                  align-items: center;

                  .star-img {
                    width: 10px;
                    height: 10px;
                    display: block;
                  }

                  .star-text {
                    padding-top: 3px;
                    margin-left: 3px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/recommended.vue